import React, {Component, Fragment} from 'react';
import Moment from 'moment';
import SubHeading from 'Components/SubHeading';
import {AVG_DISTANCE, ACC, GREEN_PLY, CENTURY_PLY, BEAM, DEEPAK_PHENOLICS_SAP} from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import { isCoromandel } from 'Utils/index';

class LivePreview extends Component {
    render() {
        const {trip, rfqServiceType, rfqType, disablePlacementTime, lppDetails} = this.props;
        let tat = 0;
        let tatUOM = '';
        const user = getUser();
        const isACC = (user.companyId === ACC);
        const isCPLY = CENTURY_PLY.includes(user.companyId);
        const beam = BEAM.includes(user.companyId);
        const isDPLSAP = DEEPAK_PHENOLICS_SAP.includes(user.companyId);
        if (trip.biddingDetails && ((isCPLY || beam) ? trip.distance : Object.keys(lppDetails).length > 0)) {
            tat = trip.biddingDetails.tatValue ? trip.biddingDetails.tatValue : (Math.round(parseFloat(((isCPLY ? trip.distance : lppDetails.distance) || "").replace(/[\s,]+/g,'')) / (GREEN_PLY.includes(getUser().companyId) ? (trip.requiredVehicleCapacity > 16 ? 300 : 350) : AVG_DISTANCE)));
            tatUOM = trip.biddingDetails && trip.biddingDetails.tatUnit ? trip.biddingDetails.tatUnitName : 'Days';
        }
        return (
            <div>
                <div className="mb-50">
                    <SubHeading text="Vehicle Details" className="mb-20 pb-5 border-bottom-light"/>
                    {(rfqServiceType === 1 || rfqServiceType || 4) &&<Fragment>
                        <div className="fs-16 caption-color fSemibold mb-5">Vehicle</div>
                        <div className="fs-16 header-medium-color fSemibold mb-20">{trip.vehicleTypeName || '-'}</div>
                        
                        <div className="fs-16 caption-color fSemibold mb-5">Body Type</div>
                        <div className="fs-16 header-medium-color fSemibold mb-20">{trip.vehicleBodyTypeName || '-'}</div>
                    </Fragment>}
                    {!disablePlacementTime && <div className="fs-16 caption-color fSemibold mb-5">Placement Time</div>} 
                    {!disablePlacementTime && <div className="fs-16 header-medium-color fSemibold mb-20">{Moment(trip.placementTime).format('DD MMM YYYY HH:mm a')|| '-'}</div>}
                </div>
                <div className="mb-40">
                    <SubHeading text="Stops" className="mb-20 pb-5 border-bottom-light"/>
                    <div className="flex flex-between mb-30">
                        <div className="col-2 mr-10">
                            <div className="fs-16 caption-color fSemibold mb-5">From (Start Point)</div>
                                <div className="fs-16 header-medium-color fSemibold mb-10">
                                {(rfqType === 1 && (rfqServiceType === 1 || rfqServiceType === 4) && (trip.stops.length > 0)? trip.stops[0].location:'')}
                                {(rfqType === 1 && (rfqServiceType === 2 || rfqServiceType === 3) && trip.lclStops.length > 0)? trip.lclStops[0].from.location:''}
                                {((rfqType === 2 || rfqType === 5) && trip.legs.length > 0)? trip.legs[0].from.location:''}
                                </div>
                        </div>
                        <div className="col-2 ml-10">
                            <div className="fs-16 caption-color fSemibold mb-5">To (Final Destination)</div>
                            <div className="fs-16 header-medium-color fSemibold mb-10">
                                {(rfqType === 1 && (rfqServiceType === 1 || rfqServiceType === 4) && trip.stops.length > 0)? trip.stops[1].location:''}
                                {(rfqType === 1 && (rfqServiceType === 2 || rfqServiceType === 3) && trip.lclStops.length > 0)? trip.lclStops[trip.lclStops.length - 1].to.location:''}
                                {((rfqType === 2 || rfqType === 5) && trip.legs.length > 0)? trip.legs[trip.legs.length - 1].to.location:''}
                            </div>
                        </div>
                    </div>
                    {!isACC && !isCoromandel() && <div>
                        <div className="fs-16 caption-color fSemibold mb-5">Distance</div>
                        <div className="fs-16 header-medium-color fSemibold mb-10">
                            {(isCPLY || beam ||isDPLSAP) ? trip.distance : ((lppDetails && lppDetails.distance) ? lppDetails.distance : 0)} {' '}
                            {(isCPLY || beam ||isDPLSAP) ? trip.distance_uom : ((lppDetails && lppDetails.distance_uom) ? lppDetails.distance_uom : '')}
                            {(lppDetails && lppDetails.is_km_inserted_by) ? <span>({(lppDetails.is_km_inserted_by || '').toUpperCase()})</span> : ''}
                        </div>
                    </div>}
                    {isCoromandel() && <div>
                        <div className="fs-16 caption-color fSemibold mb-5">Distance</div>
                        <div className="fs-16 header-medium-color fSemibold mb-10">
                            {trip.distance ? trip.distance : (lppDetails && lppDetails.distance)}
                            {trip.distanceUOM ? trip.distanceUOM : (lppDetails && lppDetails.distance_uom)}
                            {trip.is_km_inserted_by && `(${(trip.is_km_inserted_by ? ((trip.is_km_inserted_by || "").toLowerCase()) : ((lppDetails.is_km_inserted_by || '')).toLowerCase())})`}
                        </div>
                    </div>}
                </div>
                <div className="mb-40">
                    <SubHeading text="Bidding And Payment" className="mb-20 pb-5 border-bottom-light"/>
                    <div className="flex flex-between flex-wrap">
                        <div className="col-1 mb-20">
                            <div className="fs-16 caption-color fSemibold mb-5">Bidding Span</div>
                            {trip.biddingDetails && trip.biddingDetails.from && <div className="fs-16 header-medium-color fSemibold mb-10">{Moment(trip.biddingDetails.from).format('DD MMM YYYY hh:mm A') +  ' to ' + Moment(trip.biddingDetails.to).format('DD MMM YYYY hh:mm A')  }</div>}

                        </div>
                        <div className="col-2 mb-20">
                            <div className="fs-16 caption-color fSemibold mb-5">Pricing Basis</div>
                            <div className="fs-16 header-medium-color fSemibold mb-10">{trip.biddingDetails && trip.biddingDetails.pricingBasis?trip.biddingDetails.pricingBasisName: ''}</div>

                        </div>
                        <div className="col-2 mb-20">
                            <div className="fs-16 caption-color fSemibold mb-5">Ceiling Price</div>
                            <div className="fs-16 header-medium-color fSemibold mb-10">{(trip.biddingDetails && trip.biddingDetails.qbr) || '-'} </div>

                        </div>
                        {!isCoromandel() &&<div className="col-2 mb-20">
                            <div className="fs-16 caption-color fSemibold mb-5">TAT</div>
                            <div className="fs-16 header-medium-color fSemibold mb-10">{(trip.biddingDetails && tat) || '0'} {tatUOM}</div>
                        </div>}
                        {isCoromandel() && <div className="col-2 mb-20">
                            <div className="fs-16 caption-color fSemibold mb-5">TAT</div>
                            <div className="fs-16 header-medium-color fSemibold mb-10">{(trip.biddingDetails.tatUnit && (trip.biddingDetails.tatValue)) ? (`${trip.biddingDetails.tatValue} ${trip.biddingDetails.tatUnitName}`) : (`${trip?.tat || ""} ${trip.tat_unit || ""}`)}</div>
                        </div>}
                        <div className="col-2 mb-20">
                            <div className="fs-16 caption-color fSemibold mb-5">Business Volume</div>
                            <div className="fs-16 header-medium-color fSemibold mb-10">{(trip.biddingDetails && trip.biddingDetails.businessVolumeValue) || '-'} {(trip.biddingDetails && trip.biddingDetails.businessVolumeUnit)?trip.biddingDetails.businessVolumeUnitName: ''}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default LivePreview;
